/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import Vue from 'vue';
import breadcrumbs from './Breadcrumbs.vue';

const bc = new Vue({
  data: {
    crumbs: [],
  },

  methods: {
    add(arr) {
      this.crumbs = arr;
    },
    append(arr) {
      arr.forEach((crumb) => this.crumbs.push(crumb));
    },
    reset() {
      this.crumbs = [];
    },
  },
});

export default {
  install(Vue) {
    Vue.prototype.$breadcrumbs = bc;
    Vue.component('Breadcrumbs', breadcrumbs);
  },
};
